import { RoleConditional, RoleConditionalProps } from './RoleConditional';

export const StudentConditional = (props: RoleConditionalProps) =>
  RoleConditional(props, ['STUDENT']);

export default StudentConditional;
